import React, { useState } from "react";
import { usePopper } from "react-popper";
import styles from "./tooltip.module.scss";

const Tooltip = ({ children, content }) => {
  const [visible, setVisible] = useState(false);
  const [referenceElement, setReferenceElement] = useState(null);
  const [popperElement, setPopperElement] = useState(null);

  const { styles: popperStyles, attributes } = usePopper(
    referenceElement,
    popperElement,
    {
      placement: "top-start",
      modifiers: [
        {
          name: "offset",
          options: {
            offset: [0, 8],
          },
        },
      ],
    },
  );

  const handleClick = () => {
    setVisible(!visible);
  };

  React.useEffect(() => {
    if (visible) {
      const handleOutsideClick = (event) => {
        if (
          referenceElement &&
          !referenceElement.contains(event.target) &&
          popperElement &&
          !popperElement.contains(event.target)
        ) {
          setVisible(false);
        }
      };

      document.addEventListener("mousedown", handleOutsideClick);
      return () => {
        document.removeEventListener("mousedown", handleOutsideClick);
      };
    }
  }, [visible, referenceElement, popperElement]);

  return (
    <>
      <div
        ref={setReferenceElement}
        onClick={handleClick}
        className={styles.tooltipTrigger}
      >
        {children}
      </div>
      {visible && (
        <div
          ref={setPopperElement}
          style={popperStyles.popper}
          className={styles.tooltip}
          {...attributes.popper}
        >
          {content}
          <div className={styles.arrow} />
        </div>
      )}
    </>
  );
};

export default Tooltip;
